import { render, staticRenderFns } from "./CategorySales.vue?vue&type=template&id=d08e67d8"
import script from "./CategorySales.vue?vue&type=script&lang=js"
export * from "./CategorySales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports